export default __webpack_public_path__ + "static/media/granite_256x256.f9e61cca.png";